import { createContext, useContext, useRef, type ReactNode } from "react";
import LoadingBar from "react-top-loading-bar";
import type { LoadingBarRef } from "react-top-loading-bar";

export interface LoadingBarApi {
  start: () => void;
  complete: () => void;
}

const LoadingBarContext = createContext<LoadingBarApi | null>(null);

interface LoadingBarProviderProps {
  children: ReactNode;
  color?: string;
  height?: number;
}

export function LoadingBarProvider({
  children,
  color = "#2563eb",
  height = 3
}: LoadingBarProviderProps) {
  const loadingBarRef = useRef<LoadingBarRef | null>(null);

  const api: LoadingBarApi = {
    start: () => {
      if (loadingBarRef.current) loadingBarRef.current.continuousStart();
    },
    complete: () => {
      if (loadingBarRef.current) loadingBarRef.current.complete();
    },
  };

  return (
    <LoadingBarContext.Provider value={api}>
      <LoadingBar color={color} ref={loadingBarRef} height={height} shadow={true} />
      {children}
    </LoadingBarContext.Provider>
  );
}

export function useLoadingBar(): LoadingBarApi {
  const context = useContext(LoadingBarContext);
  if (!context) {
    throw new Error('useLoadingBar must be used within a LoadingBarProvider');
  }
  return context;
}
